import "./lib/sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./lib/i18n";
import { clearSampleData, seedSampleData } from "./lib/seedData";
import { registerServiceWorker } from "./lib/registerServiceWorker";
import { runtimeMode } from "./lib/runtimeMode";

// Apply stored theme before first paint to avoid flash
const storedTheme = localStorage.getItem("washpump_theme") || "dark";
const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
const isDark = storedTheme === "dark" || (storedTheme === "system" && systemDark);
document.documentElement.classList.toggle("light", !isDark);
document.documentElement.classList.toggle("dark", isDark);

// Sample data is for local demo mode only; live mode clears any copy left by older builds.
if (runtimeMode.isLocalDemoMode) {
  seedSampleData();
} else {
  clearSampleData();
}
registerServiceWorker();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
